export const initialErrors = {
  id: null,
  provinces: null,
  cities: null,
  driver: null,
  isActive: null,
};

export type initialErrorsType = typeof initialErrors;

export const AreasTableHeader = [
  {
    id: 'title',
    numeric: true,
    label: 'Title',
  },
  {
    id: 'provinces',
    numeric: true,
    label: 'Provinces',
  },
  {
    id: 'cities',
    numeric: true,
    label: 'Cities',
  },
  {
    id: 'Driver',
    numeric: true,
    label: 'Driver',
  },
  {
    id: 'isActive',
    numeric: true,
    label: 'Status',
  },
  {
    id: '',
    numeric: false,
    label: '',
  },
];

export const sortByTypes = [
  { label: 'Created Order', value: '_id' },
  { label: 'Last Update', value: 'updatedAt' },
];

export const sortTypes = [
  { label: 'Asc', value: 'asc' },
  { label: 'Desc', value: 'desc' },
];
